import { render, staticRenderFns } from "./smart.vue?vue&type=template&id=b4bccc48&scoped=true&"
import script from "./smart.vue?vue&type=script&lang=js&"
export * from "./smart.vue?vue&type=script&lang=js&"
import style0 from "./smart.vue?vue&type=style&index=0&id=b4bccc48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bccc48",
  null
  
)

export default component.exports